export default function parsePlaylist(playlist) {
    const streams = playlist.split(/\r?\n/).reduce((acc, line) => {
        const [key, value] = line.split('=');
        if (key.trim().startsWith('File')) {
            acc.push(value.trim());
        }
        return acc;
    }, []);
    return streams;
}
